import React from "react";


import ActiveJobTable from "./JobTableComponent/ActiveJobTable";

const JobActive = ({ setActive, setJobLenght, data, isLoading, message, isError }) => {



  return (
    <div>
      <ActiveJobTable
        setActive={setActive}
        data={data}
        isLoading={isLoading}
        pageHeader={"Active"}
        message={message}
        isError={isError}
        setJobLenght={setJobLenght}
        headerTitles={[
          "Jobs",
          "Openings",
          "Opening Date",
          "Expiry Date",
          "Employment Type",
          "Team",
          "Location",
          "Workplace Type",
          "Recruiter Tagged",
          "Hiring Manager",
          "Age (in days)",
        ]}
        active={0}
      />
    </div>
  );
};

export default JobActive;
